import React, { useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import BackGroundColor from "../CommanComponents/BackGroundColor";
import api from "../utils/api";
const Verification = () => {
  const [code, setCode] = useState(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const inputs = useRef([]);
  const navigate = useNavigate();
  const location = useLocation();

  // Kayıt sayfasından gelen emaili alıyoruz
  const email = location.state?.email || "";

  const handleChange = (element, index) => {
    if (isNaN(element.value)) return false;

    const newCode = [...code];
    newCode[index] = element.value;
    setCode(newCode);

    // Bir sonraki kutuya odaklan
    if (element.value !== "" && index < 5) {
      inputs.current[index + 1].focus();
    }
  };

  const handleVerify = async () => {
    const finalCode = code.join("");
    if (finalCode.length < 6) {
      setError("Lütfen 6 haneli kodu eksiksiz girin.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const res = await api.post("verify_email", {
        email,
        code: finalCode,
      });
      alert(res.data.message);
      navigate("/login"); // Başarılıysa girişe yönlendir
    } catch (err) {
      setError(err.res?.data?.message || "Doğrulama başarısız.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4 "
      style={{
        fontFamily: "Inter, system-ui, -apple-system, sans-serif ",
      }}
    >
      <BackGroundColor />
      <div className="max-w-md w-full  bg-white rounded-2xl shadow-xl px-8 py-14  space-y-6 z-50">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-gray-800">
            E-postanı Doğrula
          </h2>
          <p className="text-gray-600 mt-2">
            <span className="font-normal">{email}</span> adresine gönderilen 6
            haneli kodu girin.
          </p>
        </div>

        <div className="flex justify-between gap-2">
          {code.map((data, index) => (
            <input
              key={index}
              type="text"
              maxLength="1"
              ref={(el) => (inputs.current[index] = el)}
              value={data}
              onChange={(e) => handleChange(e.target, index)}
              onKeyDown={(e) => {
                if (e.key === "Backspace" && !code[index] && index > 0) {
                  inputs.current[index - 1].focus();
                }
              }}
              className="w-10 h-12 text-center text-md font-semibold border-1 
               rounded-lg focus:border-purple-600 focus:outline-none transition-all  focus:bg-gray-100"
            />
          ))}
        </div>

        {error && <p className="text-red-500 text-sm text-center">{error}</p>}

        <button
          onClick={handleVerify}
          disabled={loading}
          className={`w-full py-3 rounded-xl font-semibold text-white transition-all ${
            loading
              ? "bg-gray-400"
              : "bg-purple-500 hover:bg-purple-600 shadow-lg shadow-purple-200"
          }`}
        >
          {loading ? "Doğrulanıyor..." : "Hesabı Onayla"}
        </button>

        <div className="text-center">
          <button
            className="text-purple-500 hover:underline text-sm font-medium"
            onClick={() => {
              /* Tekrar gönder fonksiyonu buraya gelebilir */
            }}
          >
            Kodu tekrar gönder
          </button>
        </div>
      </div>
    </div>
  );
};

export default Verification;
